import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-career',
  templateUrl: './career.component.html',
  styleUrls: ['./career.component.scss']
})
export class CareerComponent implements OnInit {


  public careers:Array<{id: number, title: string, image: string}> = [
      {id: 1, title: 'Administración', image:'https://conceptodefinicion.de/wp-content/uploads/2014/11/Administraci%C3%B3n-2.jpg'},
      {id: 2, title: 'Contabilidad', image:'https://blogs.funiber.org/wp-content/uploads/2018/02/funiber-contabilidad-costos.jpg'},
      {id: 3, title: 'Ing. de Sistemas', image: 'https://noticias.universia.net.co/net/images/educacion/p/po/por/por-que-estudiar-ingenieria-de-sistemas-1546514917249.jpg'},
      {id: 4, title: 'Derecho', image: 'http://abogaciaempresarial.com/blog/wp-content/uploads/2018/10/derecho-fiscal-805x536.jpg'},
  ];

  constructor(public route : Router) { }

  ngOnInit() {
    console.log(this.careers);
  }
  public showCareer(career){
    this.route.navigate(['workshop/:'+career.id]);
  }
}
